import React from 'react'
import PropTypes from 'prop-types'
import { DatePicker as AntDatePicker } from 'antd'
import moment from 'moment'
import './../../ui.style.scss'
import './DatePicker.scss'

const DatePicker = ({ date, dateFormat, onChange, disabledDate, placeholder, allowClear, use12Hours, disabledTime, disabled, onOpenChange, status, showTime = null, ...props }) => {
  return (
    <AntDatePicker
      className={`${status === 'error' ? 'date-picker-error' : ''} date-picker`}
      use12Hours={use12Hours}
      disabledDate={disabledDate}
      disabledTime={disabledTime}
      allowClear={allowClear}
      showTime={showTime || {
        use12Hours: use12Hours,
        onAmPmChange: () => {},
        format: 'HH:mm:ss'
      }}
      value={date ? moment(date, dateFormat) : null}
      format={dateFormat}
      onChange={onChange}
      onOpenChange={onOpenChange || (() => {})}
      placeholder={placeholder}
      disabled={disabled} />
  )
}

DatePicker.propTypes = {
  /** Date value of Datepicker. */
  date: PropTypes.string,
  /** Date format of Datepicker. */
  dateFormat: PropTypes.string,
  /** Date change action of Datepicker. */
  onChange: PropTypes.func,
  /** Placeholder of Datepicker. */
  placeholder: PropTypes.string,
  /** Date display decision maker function of Datepicker. */
  disabledDate: PropTypes.func,
  /** Boolean for display clear icon */
  allowClear: PropTypes.bool
}

DatePicker.defaultProps = {
  dateFormat: 'YYYY-MM-DD',
  allowClear: true,
  use12Hours: true
}

export default DatePicker
